<template>
  <div class="page1 page">
    <div class="container container-p-top">
      <p>921大地震一晃眼20年，但在幾次大地震中負傷的公共建築卻尚未復元。本報調查發現，20年來重要公共建築的耐震補強進度慢如牛步，尤其最高行政機關行政院的補強率竟然掛零，帶頭做了壞榜樣。地方政府則是屏東縣吊車尾，104棟建築只補強6棟，補強率連一成都不到。</p>
      <p>民國88年發生921大地震，造成重大災難，當年12月30日政府火速修正建築技術規則，提高建築耐震的設計標準。為了確保下次震災發生時，公共建築能發揮應有的功能，<span class="bold">內政部89年起就請中央各部會和地方政府自行提報需要評估耐震能力的公有建築，特別是86年5月1日前依舊版耐震法規領取建照的公共建築，總數逾3萬棟。</span></p>
      <p>「災後供避難、救助、醫療等功能的公共建築，幾乎都納進來了。」營建署建築管理組組長高文婷說，這些重要公共建築必須符合大震不倒、中震可修、小震不壞的基本原則，才不致在地震中先成了受災戶。</p>
      <h3>中央部會補強率83.7% 醫院、長照機構不耐震</h3>
      <p>但本報掌握內政部「<a href="http://cpabm.cpami.gov.tw/k-inx/" aria-label="建築物實施耐震能力評估及補強資訊管理系統" class="link-green" target="_blank">建築物實施耐震能力評估及補強資訊管理系統</a>」的統計顯示，列管的老舊公有建築30,041棟，需補強9,946棟，花了20年，總補強率僅達78.8%；其中，中央部會2,236棟需補強的建築，還有365棟未補強，執行率83.7%，<span class="bold">特別是<span class="marked">行政院</span>，包含中央大樓在內的7棟大樓都需要補強，但進度掛零，至今文風不動。</span></p>
      <h4 class="container-top">中央部會公家建築補強執行率</h4>
      <div class="chart1">
        <div class="bars">
          <div class="bar" v-for="(item, index) in chart1" :key="index">
            <div class="bar_name">{{item.name}}</div>
            <div class="bar_container">
              <div class="bar_container_bar" :style="`width:${item.percentage}%;`"></div><div class="bar_container_number">{{item.percentage}}%</div>
            </div>
          </div>
          <div class="bars_dash">
            <div class="bars_dash_name"></div>
            <div class="bars_dash_bar">
              <div class="bars_dash_bar_mid"></div>
              <div class="bars_dash_bar_0">0</div>
              <div class="bars_dash_bar_50">50</div>
              <div class="bars_dash_bar_100">100</div>
            </div>
          </div>
        </div>
        <div class="chart_legend"><p>補強率</p></div>
        <div class="chart_description mb-225">
          <p>資料來源：<a href="http://cpabm.cpami.gov.tw/k-inx/" target="_blank" class="link-green">營建署建築物耐震補強資訊管理系統</a></p>
          <p>統計日期：2019年8月12日</p>
          <p>註：行政院環保署、外交部需補強建物件數為0，故未在圖表中呈現。</p>
        </div>
      </div>
      <p>營建署官員表示，每年都與各主管機關定期檢討執行進度，行政院7棟大樓的耐震詳細評估均已完成，但顧及補強時，人員要變換辦公地點相當麻煩，才拖到現在仍無下文；行政院承諾112年完成補強。</p>
      <p>中央各部會的補強率落差大，進度掛零的有行政院、 國發會，國防部、科技部則已全數完成補強，教育部在特別預算的支持下，學校校舍等補強也可望趕在今年百分百達標。其餘<span class="bold">攸關災後安置、醫療等救援功能的<span class="marked">內政部</span>與<span class="marked">衛福部</span>，補強率各約為66%及87%，內政部監督整個補強方案，還有39棟未補強，自失立場。</span></p>
      <p>該資訊系統顯示，衛福部尚未補強的建築，除國民健康署台北辦公室等少數辦公大樓，<span class="bold">多數集中在台中、南投、台南等部立醫院和屏東、花蓮玉里等地區醫院，甚至包含護理之家等長照機構，萬一再受大地震影響醫療功能，後果堪慮。</span></p>
      <h3 class="container-top">地方政府補強率48.4% 屏東縣吊車尾</h3>
      <p>地方政府公有建築補強率更慘不忍睹，整體補強率不到一半，僅48.4%。<span class="bold">補強率吊車尾的是<span class="marked">屏東縣</span>，還不到6%，其餘後段班縣市依序是<span class="marked">苗栗</span>、<span class="marked">彰化</span>、<span class="marked">南投</span>、<span class="marked">雲林</span>；<span class="marked">台北市</span>以將近86%補強率奪冠。</span></p>
      <h4 class="container-top">地方政府公家建築補強執行率</h4>
      <div class="chart2">
        <div class="bars">
          <div class="bar" v-for="(item, index) in chart2" :key="index">
            <div class="bar_name">{{item.name}}</div>
            <div class="bar_container">
              <div class="bar_container_bar" :style="`width:${item.percentage}%`"></div><div class="bar_container_number">{{item.percentage}}%</div>
            </div>
          </div>
          <div class="bars_dash">
            <div class="bars_dash_name"></div>
            <div class="bars_dash_bar">
              <div class="bars_dash_bar_mid"></div>
              <div class="bars_dash_bar_0">0</div>
              <div class="bars_dash_bar_50">50</div>
              <div class="bars_dash_bar_100">100</div>
            </div>
          </div>
        </div>
        <div class="chart_legend"><p>補強率</p></div>
        <div class="chart_description mb-225">
          <p>資料來源：<a href="http://cpabm.cpami.gov.tw/k-inx/" target="_blank" class="link-green">營建署建築物耐震補強資訊管理系統</a></p>
          <p>統計日期：2019年8月12日</p>
          <p>註：金門縣政府需補強建物件數為0，故未在圖表中呈現。</p>
        </div>
      </div>
      <h3>地方政府喊窮 機關首長不重視</h3>
      <p>營建署官員表示，<span class="bold">以往中央未補助地方執行耐震評估及補強，各機關首長不重視或財政困難，都是進度拖延主因</span>，直到106年發生美濃大地震，台南維冠金龍大樓倒塌後，行政院才以前瞻基礎建設計畫經費補助地方做耐震補強，並依地方財政分級，要求地方自籌一到三成不等的配合款，但地方還是叫窮，是推動瓶頸。</p>
      <p>屏東縣城鄉發展處長李怡德表示，列管的待補強名單，不少是鄉鎮公所管理的建物，有的因自籌款不足、有的可能使用率不高未列優先補強，或因補強須搬遷而影響意願，在縣府大力催促下，補強率可望從個位數提升至2成6。</p>
      <p><span class="bold">苗栗、雲林、南投等縣市的補強率敬陪末座，歸咎主因「都是錢的問題」</span>。雲林縣府建設處長李俊興說，<span class="bold">需要補強的多是鄉鎮公所活動中心及消防分隊、派出所等</span>，雖有救災功能，但各鄉鎮財政困難，提出補強的補助申請後，不少因此撤案。目前已與當地學校及旅館民宿業者簽訂開口合約，震災時可作臨時安置處所。南投縣建設處長李正偉說，一棟建築補強要花上百萬元，中央不補助，地方籌錢實在很難。</p>
    </div>
    <Next href="./damaged_building" class="container-top">
      <span>近斷層老舊建築<br v-if="!this.isWeb"> 全台5萬棟暗藏風險</span>
    </Next>
  </div>
</template>

<script>
import Relate from '../../../general_components/Relate.vue'
import Comment from '../../../general_components/Comment.vue'
import Logo from '../../../general_components/Logo.vue'
import Author from '../../../general_components/Author.vue'
import Footer from '../../../general_components/Footer.vue'
import Next from '../components/Next.vue'
export default {
  name: 'page1',
  components: {
    Relate,
    Comment,
    Logo,
    Author,
    Footer,
    Next
  },
  data() {
    return {
      isWeb: false,
      explanationFlag: false,
      chart1: [
        {
          name: '行政院',
          percentage: 0.0
        },
        {
          name: '國家發展委員會',
          percentage: 0.0
        },
        {
          name: '海洋委員會',
          percentage: 1.4
        },
        {
          name: '勞動部',
          percentage: 33.3
        },
        {
          name: '行政院主計總處',
          percentage: 33.3
        },
        {
          name: '國家通訊傳播委員會',
          percentage: 50.0
        },
        {
          name: '內政部',
          percentage: 65.8
        },
        {
          name: '財政部',
          percentage: 67.8
        },
        {
          name: '交通部',
          percentage: 74.6
        },
        {
          name: '法務部',
          percentage: 80.5
        },
        {
          name: '行政院農業委員會',
          percentage: 84.4
        },
        {
          name: '教育部',
          percentage: 85.7
        },
        {
          name: '衛生福利部',
          percentage: 87.4
        },
        {
          name: '經濟部',
          percentage: 87.6
        },
        {
          name: '文化部',
          percentage: 91.7
        },
        {
          name: '教育部_教育單位',
          percentage: 98.8
        },
        {
          name: '教育部_其他教育單位',
          percentage: 98.8
        },
        {
          name: '行政院原子能委員會',
          percentage: 100.0
        },
        {
          name: '國防部',
          percentage: 100.0
        },
        {
          name: '科技部',
          percentage: 100.0
        },
        {
          name: '金融監督管理委員會',
          percentage: 100.0
        },
        {
          name: '退輔會',
          percentage: 100.0
        },
        {
          name: '行政院人事行政總處',
          percentage: 100.0
        }       
      ],
      chart2: [
        {
          name: '屏東縣',
          percentage: 5.8
        },
        {
          name: '苗栗縣',
          percentage: 7.5
        },
        {
          name: '彰化縣',
          percentage: 18.9
        },
        {
          name: '南投縣',
          percentage: 19.6
        },
        {
          name: '雲林縣',
          percentage: 27.3
        },
        {
          name: '基隆市',
          percentage: 44.8
        },
        {
          name: '新竹縣',
          percentage: 45.5
        },
        {
          name: '嘉義市',
          percentage: 45.5
        },
        {
          name: '花蓮縣',
          percentage: 47.8
        },
        {
          name: '嘉義縣',
          percentage: 49.4
        },
        {
          name: '高雄市',
          percentage: 50.0
        },
        {
          name: '澎湖縣',
          percentage: 50.0
        },
        {
          name: '連江縣',
          percentage: 50.0
        },
        {
          name: '臺東縣',
          percentage: 52.4
        },
        {
          name: '臺南市',
          percentage: 59.3
        },
        {
          name: '新竹市',
          percentage: 59.3
        },
        {
          name: '臺中市',
          percentage: 62.1
        },
        {
          name: '新北市',
          percentage: 63.7
        },
        {
          name: '桃園市',
          percentage: 67.3
        },
        {
          name: '宜蘭縣',
          percentage: 74.6
        },
        {
          name: '臺北市',
          percentage: 85.9
        }     
      ]
    }
  },
  methods: {
    srcRWD(mob,web){
      if(this.isWeb==false){
        return mob;
      }else{
        return web;
      }
    },
    explanation_click(){
      if(!this.explanationFlag){
        ga('newmedia.send', {
          hitType: 'event',
          eventCategory: 'dictionary',
          eventAction: 'Click',
          eventLabel: `[${this.detectPlatform()}] [${document.querySelector('title').innerHTML}] [earthquake_resistance]`,
        })
      }
      this.explanationFlag = !this.explanationFlag
    },
    detectPlatform() {
      if( navigator.userAgent.match(/Android/i)
          || navigator.userAgent.match(/webOS/i)
          || navigator.userAgent.match(/iPhone/i)
          || navigator.userAgent.match(/iPad/i)
          || navigator.userAgent.match(/iPod/i)
          || navigator.userAgent.match(/BlackBerry/i)
          || navigator.userAgent.match(/Windows Phone/i)
      ){
          return 'Mob';
      }
      else {
          return 'PC';
      }
    },
  },
  created() {
    if (window.innerWidth >= 768) {
      this.isWeb = true
    }
  },
  mounted() {
    const windowHeight = window.innerHeight
    // 建立ScrollMagic.Controller
    var controller_onLeave = new ScrollMagic.Controller({globalSceneOptions: {triggerHook:'onLeave'}})
    // 建立ScrollMagic.Scene
    var bar1_scene = new ScrollMagic.Scene({triggerElement: '.chart1', duration: 0, offset: -windowHeight*0.6})
    var bar2_scene = new ScrollMagic.Scene({triggerElement: '.chart2', duration: 0, offset: -windowHeight*0.6})
    // bar1
    bar1_scene
    // .addIndicators({})
    .on('enter', () => {
      TweenMax.staggerFrom(".chart1 .bar_container_bar", 1, {
        scaleX: 0,
        transformOrigin: 'left',
        ease: Power0.easeNone
      },0.05)

      TweenMax.staggerTo(".chart1 .bar_container_bar", 1, {
        scaleX: 1,
        transformOrigin: 'left',
        ease: Power0.easeNone
      },0.05)

      TweenMax.staggerFrom(".chart1 .bar_container_number", 1, {
        opacity: 0,
        transformOrigin: 'left',
        ease: Power0.easeNone,
        delay: 0.5
      },0.05)

      TweenMax.staggerTo(".chart1 .bar_container_number", 1, {
        opacity: 1,
        transformOrigin: 'left',
        ease: Power0.easeNone,
        delay: 0.5
      },0.05)
      bar1_scene.destroy()
    })
    .addTo(controller_onLeave)

    // bar2
    bar2_scene
    // .addIndicators({})
    .on('enter', () => {
      TweenMax.staggerFrom(".chart2 .bar_container_bar", 1, {
        scaleX: 0,
        transformOrigin: 'left',
        ease: Power0.easeNone
      },0.05)

      TweenMax.staggerTo(".chart2 .bar_container_bar", 1, {
        scaleX: 1,
        transformOrigin: 'left',
        ease: Power0.easeNone
      },0.05)

      TweenMax.staggerFrom(".chart2 .bar_container_number", 1, {
        opacity: 0,
        transformOrigin: 'left',
        ease: Power0.easeNone,
        delay: 0.5
      },0.05)

      TweenMax.staggerTo(".chart2 .bar_container_number", 1, {
        opacity: 1,
        transformOrigin: 'left',
        ease: Power0.easeNone,
        delay: 0.5
      },0.05)
      bar2_scene.destroy()
    })
    .addTo(controller_onLeave)

  }
}
</script>
<style lang="sass" scoped>
.container-p-top
  padding-top: 60px
  @media (min-width: 768px)
    padding-top: 80px
.container-top
  margin-top: 60px
  @media (min-width: 768px)
    margin-top: 80px
.mt-225
  margin-top: 2.25rem
.mb-225
  margin-bottom: 2.25rem
.pt-225
  padding-top: 2.25rem
.bold
  font-weight: bold
.link-green
  color: #57b09f
  text-decoration: none
  border-bottom: 1px solid #57b09f
.marked
  position: relative
  white-space: nowrap
  &:after
    content: ''
    display: block
    position: absolute
    bottom: 2px
    left: 0
    width: 100%
    height: 8px
    background: #FFBB00
    z-index: -1
.chart1
  width: 100%
  .chart_legend
    position: relative
    margin-top: 40px
    margin-bottom: 2.25rem
    text-align: center
    p
      margin: 0
      font-size: 1rem
  .chart_description
    p
      margin: 0
      font-size: 15px
  .bars
    position: relative
  .bar
    display: flex
    margin: 4px 0
    width: calc(100% - 30px)
    // height: 16px
  .bar_name
    width: 160px
    text-align: right
    flex-shrink: 0
    padding-right: 5px
  .bar_container
    width: 100%
    display: flex
  .bar_container_number
    padding-left: 5px
    opacity: 0
    // position: absolute
    // top: 0
    // right: -10px
  .bar_container_bar
    position: relative
    background: #57b09f
    height: 16px
    flex-shrink: 0
    transform: scaleX(0)
  .bars_dash
    position: absolute
    z-index: -1
    width: calc(100% - 30px)
    height: 100%
    top: 0
    left: 0
    display: flex
    .bars_dash_name
      width: 160px
      flex-shrink: 0
    .bars_dash_bar
      position: relative
      width: 100%
      border-left: 1px solid #c2c2c2
      border-right: 1px solid #c2c2c2
      .bars_dash_bar_mid
        width: 50%
        height: 100%
        border-right: 1px solid #c2c2c2
      .bars_dash_bar_0
        position: absolute
        bottom: -25px
        left: 0
        transform: translate(-50%,0)
      .bars_dash_bar_50
        position: absolute
        bottom: -25px
        right: 50%
        transform: translate(50%,0)
      .bars_dash_bar_100
        position: absolute
        bottom: -25px
        right: 0
        transform: translate(50%,0)

.chart2
  width: 100%
  .chart_legend
    position: relative
    margin-top: 40px
    margin-bottom: 2.25rem
    text-align: center
    p
      margin: 0
      font-size: 1rem
  .chart_description
    p
      margin: 0
      font-size: 15px
  .bars
    position: relative
  .bar
    display: flex
    margin: 4px 0
    width: calc(100% - 30px)
    // height: 16px
  .bar_name
    width: 100px
    text-align: right
    flex-shrink: 0
    padding-right: 5px
  .bar_container
    width: 100%
    display: flex
  .bar_container_number
    padding-left: 5px
    opacity: 0
    // position: absolute
    // top: 0
    // right: -10px
  .bar_container_bar
    position: relative
    background: #57b09f
    height: 16px
    flex-shrink: 0
    transform: scaleX(0)
  .bars_dash
    position: absolute
    z-index: -1
    width: calc(100% - 30px)
    height: 100%
    top: 0
    left: 0
    display: flex
    .bars_dash_name
      width: 100px
      flex-shrink: 0
    .bars_dash_bar
      position: relative
      width: 100%
      border-left: 1px solid #c2c2c2
      border-right: 1px solid #c2c2c2
      .bars_dash_bar_mid
        width: 50%
        height: 100%
        border-right: 1px solid #c2c2c2
      .bars_dash_bar_0
        position: absolute
        bottom: -25px
        left: 0
        transform: translate(-50%,0)
      .bars_dash_bar_50
        position: absolute
        bottom: -25px
        right: 50%
        transform: translate(50%,0)
      .bars_dash_bar_100
        position: absolute
        bottom: -25px
        right: 0
        transform: translate(50%,0)

.explanation-button
    border: none
    border-radius: 4px
    color: #ffffff
    background-color: #57b09f
    cursor: pointer
    padding: 4px 5px
    margin: 0 3px
.explanation-container
  display: block
  border-radius: 6px
  padding: 30px
  margin: 1rem 0
  background-color: #c3dddd

</style>
